// extracted by mini-css-extract-plugin
export default {"wrapper":"iV-z","availablePromoMessagesLabel":"jV-z","promoMessageList":"kV-z","promoMessage":"lV-z","appliedPromoMessage":"mV-z","promoMessageAmount":"nV-z"};